import React from 'react';

const services = [
    {
        id: "01",
        title: "Website Development",
        description: "I build fast, responsive, and scalable websites tailored to your business — from landing pages to full platforms using modern technologies."
    },
    {
        id: "02",
        title: "UI/UX & Website Optimization",
        description: "I design clean, user-focused interfaces and optimize websites for speed, usability, and higher conversions."
    },
    {
        id: "03",
        title: "eCommerce Solutions",
        description: "I create high-converting online stores using Shopify and custom solutions, focused on performance, design, and seamless user experience."
    }
];

const Services = () => {
    return (
        <div className="row service-wrapper items mt-md-5">
            {services.map((service, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-4">
                    <div className="item d-flex align-items-start">
                        <div className="item-count">{service.id}</div>
                        <div className="content">
                            <h4 className="mt-0">{service.title}</h4>
                            <p>{service.description}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Services;
